import axios from 'axios';
import AuthService from './AuthService';

const API_URL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use((config) =>
  AuthService.prepareAuthenticatedRequest(config)
);

const LeadStatusService = {
  getAllLeadStatus: async () => {
    const response = await axios.get(`${API_URL}/LeadStatus/GetAllLeadStatus`);
    const data = response.data;
    return Array.isArray(data) ? data : (data?.$values || []);
  },

  getPipelineStagesByClientId: async (clientId) => {
    const response = await axios.get(`${API_URL}/LeadStatus/GetPipelineStages/${clientId}`);
    const data = response.data;
    return Array.isArray(data) ? data : (data?.$values || []);
  },

  createPipelineStage: async (dto) => {
    const response = await axios.post(`${API_URL}/LeadStatus/PipelineStage`, dto);
    return response.data;
  },

  updatePipelineStage: async (id, dto) => {
    const response = await axios.put(`${API_URL}/LeadStatus/PipelineStage/${id}`, dto);
    return response.data;
  },

  deletePipelineStage: async (id) => {
    const response = await axios.delete(`${API_URL}/LeadStatus/PipelineStage/${id}`);
    return response.data;
  },
};

export default LeadStatusService;
